export default __webpack_public_path__ + "static/media/mitigation-basement-equipment-lineup.7396aa0e.jpg";